<div class="container-fluid">
    <div class="row">
        <div class="col-md-8">
            <small class="link" (click)="backToDashboard()" *ngIf="userType == 'I9Admin'">
                Home > Employee Management
            </small>
            <div class="mat-title titleColor font-weight-bold" *ngIf="isCreateAndEdit && userType == 'Petitioner'">
                Manage
                Beneficiaries</div>
            <div class="mat-subheading-1 titleColor" *ngIf="isCreateAndEdit && userType == 'Petitioner'">Manage existing
                beneficiaries or create new</div>

            <div class="mat-title titleColor font-weight-bold" *ngIf="isCreateAndEdit && userType == 'I9Admin'">Manage
                Employees</div>
            <div class="mat-subheading-1 titleColor" *ngIf="isCreateAndEdit && userType == 'I9Admin'">Manage existing
                employees or create new</div>

        </div>

        <div class="col-md-4">
            <div class="_action">
                <button mat-flat-button color="default" (click)="openBenefiary()"
                    *ngIf="isCreateAndEdit && userType == 'Petitioner'" class="text-uppercase _btn"><mat-icon
                        class="_add">add</mat-icon>Add Beneficiary</button>
                <!-- <button mat-flat-button color="default" (click)="openBenefiary()" *ngIf="isCreateAndEdit && userType == 'I9Admin'" class="text-uppercase _btn"><mat-icon class="_add">add</mat-icon>Add Employee</button> -->
                <button mat-flat-button color="default" (click)="openFormModalCreate()"
                    *ngIf="isCreateAndEdit && userType == 'I9Admin'" class="text-uppercase _btn"><mat-icon
                        class="_add">add</mat-icon>Create New Employee</button>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="bgWhite noMargin w100">
        <div class="row">
            <div class="col-md-6 mt-3 mb-3" *ngIf="userType == 'I9Admin'">
                <div class="col-md-4 p-0">
                    <p class="label-cls ddLabel"><b>View By</b></p>
                    <p-dropdown [options]="viewEmployeeBy" [(ngModel)]="employeeViewBy" placeholder="Select a category"
                        (onChange)="viewEmployeeByChange()"></p-dropdown>
                </div>
            </div>
            <div class="col-md-3 pull-right" *ngIf="userType == 'I9Admin'">
                <div class="filterContainer">

                    <ul>
                        <li class="activeBar"><i class="fa fa-bars" aria-hidden="true"></i></li>
                        <li (click)="gridView()"><i class="fa fa-th" aria-hidden="true"></i></li>
                        <!-- Hiding for now, will enable once we get exact functionality -->
                        <!-- <li>
                            <div (click)="filterOpen()"><i class="fa fa-filter filter" aria-hidden="true"></i></div>
                        </li> -->
                    </ul>

                    <div class="filterComponent" *ngIf="isFilter" (click)="stopPropagation($event)">
                        <h2>Filter</h2>
                        <span class="close-icon" (click)="closeFilter()"><i class="fa fa-times"
                                aria-hidden="true"></i></span>
                        <div class="clearfix"></div>
                        <h3>View By</h3>

                        <div class="filterForm">
                            <label for="name">Name</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.name" id="name"
                                aria-describedby="name" placeholder="Enter Name">


                            <h3 class="mt-20">Employee having</h3>

                            <div class="form-check pull-left">
                                <input class="form-check-input filterRadio" type="radio" value="LCA"
                                    [(ngModel)]="filter.type" name="filterRadio" id="filterRadio1">
                                <label class="form-check-label filterLabel" for="filterRadio1">LCA</label>
                            </div>

                            <div class="form-check  pull-left">
                                <input class="form-check-input filterRadio" type="radio" value="I9Forms"
                                    [(ngModel)]="filter.type" name="filterRadio" id="filterRadio2">
                                <label class="form-check-label filterLabel" for="filterRadio2">I-9 Form</label>
                            </div>

                            <div class="form-check  pull-left">
                                <input class="form-check-input filterRadio" type="radio" value="EVerified"
                                    [(ngModel)]="filter.type" name="filterRadio" id="filterRadio3">
                                <label class="form-check-label filterLabel" for="filterRadio3">E-Verify</label>
                            </div>
                        </div>

                        <button class="btn btn-primary customButton" [disabled]="filter.type == '' || filter.name == ''"
                            (click)="filterAction()">Submit</button>
                    </div>
                </div>
            </div>
           

            <div class="col-md-8" *ngIf="userType !== 'I9Admin'">

                <div class="mt-2 row tab-container tab-height">
                  <div class="col-2 mr-2 ml-1 icn" [class.activeTab]="beneficiaryStatus === 'ACTIVE'"
                    (click)="getBeneficiaryWithStatus('ACTIVE')">
                    <div class="lbl-text">Current ({{totalActiveRecords}})</div>
                  </div>
                  <div class="col-2 mr-2 ml-1 icn" [class.activeTab]="beneficiaryStatus === 'PEND'"
                    (click)="getBeneficiaryWithStatus('PEND')">
                    <div class="lbl-text">Pending ({{totalPendingRecords}})</div>
                  </div>
                  <div class="col-2 mr-2 ml-1 icn" [class.activeTab]="beneficiaryStatus === 'TERMINATED'"
                    (click)="getBeneficiaryWithStatus('TERMINATED')">
                    <div class="lbl-text">Past ({{totalPastRecords}})</div>
                  </div>
                  <div class="col-3 mr-2 ml-1 icn" [class.activeTab]="beneficiaryStatus === 'PETITION_APPROVED'"
                    (click)="getBeneficiaryWithStatus('PETITION_APPROVED')">
                    <div class="lbl-text">Approved Petitions<ng-container *ngIf="totalPetitionApprovedRecords">({{totalPetitionApprovedRecords}})</ng-container></div>
                  </div>
                </div>
              </div>
        
              <div class="col-md-2 mt-3 mb-3" *ngIf="userType !== 'I9Admin'">
                <div class="form-group attrny-bene-list-compny-selctbx">
                  <p-dropdown (onChange)="handleCompanyChange()" [options]="listOfClientCompanies"
                    [(ngModel)]="selectedCompanyId" optionValue="petitionerId" placeholder="Select by Company"
                    optionLabel="petitionerName" [showClear]="false"></p-dropdown>
                </div>
              </div>

              <div class="col-md-2 mt-3 mb-3" [ngClass]="userType === 'I9Admin' ? 'col-md-3' : 'col-md-2'">
                <div class="input-group srch-box">
                    <input class="form-control py-2 rounded-pill pr-5" type="search" 
                        #searchBeneficiaryListTable 
                        [placeholder]="userType == 'I9Admin' ? 'Search Employee' : 'Search Beneficiary'" 
                        [(ngModel)]="searchText"> <!-- Use two-way data binding -->
            
                    <span class="input-group-append">
                        <button (click)="resetSearch()" class="srch-btn" type="button">
                            <i class="fa fa-search"></i>
                        </button>
                        <button *ngIf="searchText" (click)="resetSearch()" class="srch-close-btn" type="button">
                            <i class="fa fa-times"></i> <!-- "X" icon -->
                        </button>
                    </span>
                </div>
            </div>
            </div>

            <div *ngIf="beneficiaryStatus === 'PETITION_APPROVED'" class="row migrate-action-section mb-4 pl-3">
                <div *ngIf="this.totalRecordCount > 0" class="_action">
                  <button [disabled]="this.selection.selected.length < 1" mat-flat-button color="default" (click)="migrateBeneficiary()" class="_btn">Onboard Individuals</button>
                </div> 
                <span class="ml-3" [hidden]="this.selection.selected.length < 1">{{this.selection.selected.length}} Individuals selected to be Onboarded</span>
            </div>

        <div class="mat-elevation-z8 mt-2" *ngIf="userType === 'I9Admin'">
            <div *ngIf="employeeViewBy == 'activeEmployees'">
                <mat-tab-group [(selectedIndex)]="currentTabIndex" (selectedTabChange)="onTabChange($event)">
                    <mat-tab
                        label="All ({{allEmployeesData?.totalAllCount}})">
                        <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                <!-- Beneficiary Name Column -->
                                <ng-container matColumnDef="beneficiaryName">
                                    <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                    <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                </ng-container>

                                <!-- Email Column -->
                                <ng-container matColumnDef="email">
                                    <th mat-header-cell *matHeaderCellDef> Email </th>
                                    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                </ng-container>

                                <!-- Date of Activation Column -->
                                <ng-container matColumnDef="lastDate">
                                    <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                    <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                </ng-container>

                                <!-- Company Column -->
                                <ng-container matColumnDef="company">
                                    <th mat-header-cell *matHeaderCellDef> Company </th>
                                    <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                </ng-container>

                                <!-- Source Column -->
                                <ng-container matColumnDef="source">
                                    <th mat-header-cell *matHeaderCellDef> Source </th>
                                    <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                </ng-container>

                                <!-- Action Column -->
                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> Action </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="row">
                                            <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                [matMenuTriggerFor]="menu">
                                                <mat-icon>settings</mat-icon>
                                                <mat-icon>keyboard_arrow_down</mat-icon>
                                            </mat-icon>
                                            <mat-menu #menu="matMenu">
                                                <button mat-menu-item (click)="editPastDoc(element)">Manage I9</button>
                                                <button mat-menu-item
                                                    (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                <button mat-menu-item *ngIf="!isNonInitiated(element)"
                                                    (click)="inactivateEmployee(element, true)">Inactivate</button>
                                                <button *ngIf="!element.i9StatusCode" mat-menu-item
                                                    (click)="confirmPastDocDelete(element)">Delete</button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </ng-container>

                                <!-- Header and Row Declarations -->
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                [length]="allEmployeesData?.totalAllCount" (page)="paginationEvent($event)"></mat-paginator>
                        </div>

                        <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                        <div class="text-center mt-2 p-2" *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                            No Records
                        </div>
                    </mat-tab>


                    <mat-tab label="Not Initiated ({{allEmployeesData?.totalNotIntiatedListCount}})">
                        <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                <!-- Beneficiary Name Column -->
                                <ng-container matColumnDef="beneficiaryName">
                                    <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                    <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                </ng-container>

                                <!-- Email Column -->
                                <ng-container matColumnDef="email">
                                    <th mat-header-cell *matHeaderCellDef> Email </th>
                                    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                </ng-container>

                                <!-- Date of Activation Column -->
                                <ng-container matColumnDef="lastDate">
                                    <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                    <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                </ng-container>

                                <!-- Company Column -->
                                <ng-container matColumnDef="company">
                                    <th mat-header-cell *matHeaderCellDef> Company </th>
                                    <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                </ng-container>

                                <!-- Source Column -->
                                <ng-container matColumnDef="source">
                                    <th mat-header-cell *matHeaderCellDef> Source </th>
                                    <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                </ng-container>

                                <!-- Action Column -->
                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> Action </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="row">
                                            <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                [matMenuTriggerFor]="menu">
                                                <mat-icon>settings</mat-icon>
                                                <mat-icon>keyboard_arrow_down</mat-icon>
                                            </mat-icon>
                                            <mat-menu #menu="matMenu">
                                                <button mat-menu-item (click)="editPastDoc(element)">Manage I9</button>
                                                <button mat-menu-item
                                                    (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                <!-- <button mat-menu-item
                                                    (click)="inactivateEmployee(element, true)">Inactivate</button> -->
                                                <button mat-menu-item
                                                    (click)="confirmPastDocDelete(element)">Delete</button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </ng-container>

                                <!-- Header and Row Declarations -->
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                [length]="allEmployeesData?.totalNotIntiatedListCount" (page)="paginationEvent($event)"></mat-paginator>
                        </div>

                        <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                        <div class="text-center mt-2 p-2" *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                            No Records
                        </div>
                    </mat-tab>
                    <mat-tab label="In Progress ({{allEmployeesData?.totalInProgressListCount}})">
                        <mat-tab-group (selectedTabChange)="onInProgressTabChange($event)">
                            <mat-tab label="All ({{allEmployeesData?.totalInProgressListCount}})">
                                <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                        <!-- Beneficiary Name Column -->
                                        <ng-container matColumnDef="beneficiaryName">
                                            <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                        </ng-container>

                                        <!-- Email Column -->
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef> Email </th>
                                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                        </ng-container>

                                        <!-- Date of Activation Column -->
                                        <ng-container matColumnDef="lastDate">
                                            <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                            <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                        </ng-container>

                                        <!-- Company Column -->
                                        <ng-container matColumnDef="company">
                                            <th mat-header-cell *matHeaderCellDef> Company </th>
                                            <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                        </ng-container>

                                        <!-- Source Column -->
                                        <ng-container matColumnDef="source">
                                            <th mat-header-cell *matHeaderCellDef> Source </th>
                                            <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                        </ng-container>

                                        <!-- Action Column -->
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef> Action </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="row">
                                                    <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                        [matMenuTriggerFor]="menu">
                                                        <mat-icon>settings</mat-icon>
                                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                                    </mat-icon>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item (click)="editPastDoc(element)">Manage
                                                            I9</button>
                                                        <button mat-menu-item
                                                            (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                        <button mat-menu-item
                                                            (click)="inactivateEmployee(element, true)">Inactivate</button>
                                                    </mat-menu>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                        [length]="allEmployeesData?.totalInProgressListCount"
                                        (page)="paginationEvent($event)"></mat-paginator>
                                </div>

                                <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                                <div class="text-center mt-2 p-2"
                                    *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                                    No Records
                                </div>
                            </mat-tab>

                            <mat-tab label="Initiated ({{allEmployeesData?.totalIntiatedListCount}})">
                                <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                        <!-- Same columns as above -->
                                        <!-- Beneficiary Name Column -->
                                        <ng-container matColumnDef="beneficiaryName">
                                            <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                        </ng-container>

                                        <!-- Email Column -->
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef> Email </th>
                                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                        </ng-container>

                                       <!-- Date of Activation Column -->
                                        <ng-container matColumnDef="lastDate">
                                            <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                            <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                        </ng-container>

                                        <!-- Company Column -->
                                        <ng-container matColumnDef="company">
                                            <th mat-header-cell *matHeaderCellDef> Company </th>
                                            <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                        </ng-container>

                                        <!-- Source Column -->
                                        <ng-container matColumnDef="source">
                                            <th mat-header-cell *matHeaderCellDef> Source </th>
                                            <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                        </ng-container>

                                        <!-- Action Column -->
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef> Action </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="row">
                                                    <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                        [matMenuTriggerFor]="menu">
                                                        <mat-icon>settings</mat-icon>
                                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                                    </mat-icon>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item (click)="editPastDoc(element)">Manage
                                                            I9</button>
                                                        <button mat-menu-item
                                                            (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                        <button mat-menu-item
                                                            (click)="inactivateEmployee(element, true)">Inactivate</button>
                                                    </mat-menu>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                        [length]="allEmployeesData?.totalIntiatedListCount"
                                        (page)="paginationEvent($event)"></mat-paginator>

                                </div>

                                <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                                <div class="text-center mt-2 p-2"
                                    *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                                    No Records
                                </div>
                            </mat-tab>

                            <mat-tab label="Verify Yourself ({{allEmployeesData?.totalSelfListCount}})">
                                <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                        <!-- Same columns as above -->
                                        <!-- Beneficiary Name Column -->
                                        <ng-container matColumnDef="beneficiaryName">
                                            <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                        </ng-container>

                                        <!-- Email Column -->
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef> Email </th>
                                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                        </ng-container>

                                        <!-- Date of Activation Column -->
                                        <ng-container matColumnDef="lastDate">
                                            <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                            <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                        </ng-container>

                                        <!-- Company Column -->
                                        <ng-container matColumnDef="company">
                                            <th mat-header-cell *matHeaderCellDef> Company </th>
                                            <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                        </ng-container>

                                        <!-- Source Column -->
                                        <ng-container matColumnDef="source">
                                            <th mat-header-cell *matHeaderCellDef> Source </th>
                                            <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                        </ng-container>

                                        <!-- Action Column -->
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef> Action </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="row">
                                                    <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                        [matMenuTriggerFor]="menu">
                                                        <mat-icon>settings</mat-icon>
                                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                                    </mat-icon>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item (click)="editPastDoc(element)">Manage
                                                            I9</button>
                                                        <button mat-menu-item
                                                            (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                        <button mat-menu-item
                                                            (click)="inactivateEmployee(element, true)">Inactivate</button>
                                                    </mat-menu>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                        [length]="allEmployeesData?.totalSelfListCount"
                                        (page)="paginationEvent($event)"></mat-paginator>

                                </div>

                                <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                                <div class="text-center mt-2 p-2"
                                    *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                                    No Records
                                </div>
                            </mat-tab>


                            <mat-tab label="Video Verification ({{allEmployeesData?.totalVideoVerificationListCount}})">
                                <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                        <!-- Same columns as above -->
                                        <!-- Beneficiary Name Column -->
                                        <ng-container matColumnDef="beneficiaryName">
                                            <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                        </ng-container>

                                        <!-- Email Column -->
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef> Email </th>
                                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                        </ng-container>

                                        <!-- Date of Activation Column -->
                                        <ng-container matColumnDef="lastDate">
                                            <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                            <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                        </ng-container>

                                        <!-- Company Column -->
                                        <ng-container matColumnDef="company">
                                            <th mat-header-cell *matHeaderCellDef> Company </th>
                                            <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                        </ng-container>

                                        <!-- Source Column -->
                                        <ng-container matColumnDef="source">
                                            <th mat-header-cell *matHeaderCellDef> Source </th>
                                            <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                        </ng-container>

                                        <!-- Action Column -->
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef> Action </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="row">
                                                    <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                        [matMenuTriggerFor]="menu">
                                                        <mat-icon>settings</mat-icon>
                                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                                    </mat-icon>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item (click)="editPastDoc(element)">Manage
                                                            I9</button>
                                                        <button mat-menu-item
                                                            (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                        <button mat-menu-item
                                                            (click)="inactivateEmployee(element, true)">Inactivate</button>
                                                    </mat-menu>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                        [length]="allEmployeesData?.totalVideoVerificationListCount"
                                        (page)="paginationEvent($event)"></mat-paginator>

                                </div>

                                <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                                <div class="text-center mt-2 p-2"
                                    *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                                    No Records
                                </div>
                            </mat-tab>

                            <mat-tab label="Evaluator ({{allEmployeesData?.totalVerifyByAgentListCount}})">
                                <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                        <!-- Same columns as above -->
                                        <!-- Beneficiary Name Column -->
                                        <ng-container matColumnDef="beneficiaryName">
                                            <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                        </ng-container>

                                        <!-- Email Column -->
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef> Email </th>
                                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                        </ng-container>

                                        <!-- Date of Activation Column -->
                                        <ng-container matColumnDef="lastDate">
                                            <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                            <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                        </ng-container>

                                        <!-- Company Column -->
                                        <ng-container matColumnDef="company">
                                            <th mat-header-cell *matHeaderCellDef> Company </th>
                                            <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                        </ng-container>

                                        <!-- Source Column -->
                                        <ng-container matColumnDef="source">
                                            <th mat-header-cell *matHeaderCellDef> Source </th>
                                            <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                        </ng-container>

                                        <!-- Action Column -->
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef> Action </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="row">
                                                    <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                        [matMenuTriggerFor]="menu">
                                                        <mat-icon>settings</mat-icon>
                                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                                    </mat-icon>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item (click)="editPastDoc(element)">Manage
                                                            I9</button>
                                                        <button mat-menu-item
                                                            (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                        <button mat-menu-item
                                                            (click)="inactivateEmployee(element, true)">Inactivate</button>
                                                    </mat-menu>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                        [length]="allEmployeesData?.totalVerifyByAgentListCount"
                                        (page)="paginationEvent($event)"></mat-paginator>

                                </div>

                                <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                                <div class="text-center mt-2 p-2"
                                    *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                                    No Records
                                </div>
                            </mat-tab>

                            <mat-tab label="Authorized Person ({{allEmployeesData?.totalAuthRepresentativeListCount}})">

                                <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                        <!-- Same columns as above -->
                                        <!-- Beneficiary Name Column -->
                                        <ng-container matColumnDef="beneficiaryName">
                                            <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                        </ng-container>

                                        <!-- Email Column -->
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef> Email </th>
                                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                        </ng-container>

                                        <!-- Date of Activation Column -->
                                        <ng-container matColumnDef="lastDate">
                                            <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                            <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                        </ng-container>

                                        <!-- Company Column -->
                                        <ng-container matColumnDef="company">
                                            <th mat-header-cell *matHeaderCellDef> Company </th>
                                            <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                        </ng-container>

                                        <!-- Source Column -->
                                        <ng-container matColumnDef="source">
                                            <th mat-header-cell *matHeaderCellDef> Source </th>
                                            <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                        </ng-container>

                                        <!-- Action Column -->
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef> Action </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="row">
                                                    <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                        [matMenuTriggerFor]="menu">
                                                        <mat-icon>settings</mat-icon>
                                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                                    </mat-icon>
                                                    <mat-menu #menu="matMenu">
                                                        <button mat-menu-item (click)="editPastDoc(element)">Manage
                                                            I9</button>
                                                        <button mat-menu-item
                                                            (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                        <button mat-menu-item
                                                            (click)="inactivateEmployee(element, true)">Inactivate</button>
                                                    </mat-menu>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                        [length]="allEmployeesData?.totalAuthRepresentativeListCount"
                                        (page)="paginationEvent($event)"></mat-paginator>

                                </div>

                                <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                                <div class="text-center mt-2 p-2"
                                    *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                                    No Records
                                </div>
                            </mat-tab>
                            <mat-tab label="E-Verification Records ({{totalRecordCountEverifications}})">
                                <div *ngIf="dataSourceEverifications && dataSourceEverifications.data !=null  && dataSourceEverifications.data.length > 0">
                                    <table class="im-card-no-border-table table im-card-table-noborder-spacing" mat-table [dataSource]="dataSourceEverifications" matSort>
                                        <ng-container *ngFor="let column of eVerificationColumn" [matColumnDef]="column.columnDef">


                                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            <span>{{column.header}}</span>
                                        </th>


                                        <td mat-cell *matCellDef="let row">
                                            <span *ngIf="column.columnDef != 'action' && column.columnDef != 'everifyStatus' 
                                            && column.columnDef != 'startDate' && column.columnDef != 'endDate' && column.columnDef != 'i9InitiatedOn'">
                                            {{row[column.columnDef] ? row[column.columnDef] : 'NA' }}
                                            </span>

                                            <span *ngIf="column.columnDef == 'startDate' || column.columnDef == 'endDate' || column.columnDef == 'i9InitiatedOn'">  
                                            <span>
                                                {{row[column.columnDef] | date: 'MM/dd/yyyy' }}
                                            </span>
                                            </span>

                                            <span class="redTxt" *ngIf="column.columnDef == 'everifyStatus'"
                                            [ngClass]="{'blueTxt'  : row[column.columnDef] == 'Pending E-Verification',
                                            'greenTxt' : row[column.columnDef] == 'Employment Authorized'}"
                                            ><b>{{row[column.columnDef]}}</b></span>
                                        

                                            <div class="row" *ngIf="column.columnDef == 'action'"> 
                                            <strong>
                                                <span class="clickBtn" (click)="termsConditionsFunc(row)">E-Verify </span>|
                                                <span (click)="uploadEverifiedDocument(row)" class="clickBtn" [ngClass]="{'disabled': row['caseNumber'] == null }"> Upload Document</span>|
                                                <span (click)="editEverifiedStatus(row)" class="clickBtn"> Edit</span>
                                                </strong>
                                            </div>

                                        </td>

                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="displayedEVerifyColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedEVerifyColumns;">
                                        </tr>
                                    </table>
                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSizeEverifications"
                                        [length]="totalRecordCountEverifications"
                                        (page)="paginationEventEverifications($event)"></mat-paginator>

                                </div>

                                <mat-divider *ngIf="dataSourceEverifications && dataSourceEverifications.data !=null  && dataSourceEverifications.data.length <= 0"></mat-divider>

                                <div class="text-center mt-2 p-2"
                                    *ngIf="dataSourceEverifications && dataSourceEverifications.data !=null  && dataSourceEverifications.data.length <= 0">
                                    No Records
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-tab>
                    <mat-tab label="Completed ({{allEmployeesData?.totalCompletedListCount}})">
                        <div *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length > 0">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                <!-- Same columns as above -->
                                <!-- Beneficiary Name Column -->
                                <ng-container matColumnDef="beneficiaryName">
                                    <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                                    <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                                </ng-container>

                                <!-- Email Column -->
                                <ng-container matColumnDef="email">
                                    <th mat-header-cell *matHeaderCellDef> Email </th>
                                    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                                </ng-container>

                                <!-- Date of Activation Column -->
                                <ng-container matColumnDef="lastDate">
                                    <th mat-header-cell *matHeaderCellDef> Date of Activation </th>
                                    <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                                </ng-container>

                                <!-- Company Column -->
                                <ng-container matColumnDef="company">
                                    <th mat-header-cell *matHeaderCellDef> Company </th>
                                    <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                                </ng-container>

                                <!-- Source Column -->
                                <ng-container matColumnDef="source">
                                    <th mat-header-cell *matHeaderCellDef> Source </th>
                                    <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                                </ng-container>

                                <!-- Action Column -->
                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> Action </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="row">
                                            <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                                [matMenuTriggerFor]="menu">
                                                <mat-icon>settings</mat-icon>
                                                <mat-icon>keyboard_arrow_down</mat-icon>
                                            </mat-icon>
                                            <mat-menu #menu="matMenu">
                                                <button mat-menu-item (click)="editPastDoc(element)">Manage I9</button>
                                                <button mat-menu-item
                                                    (click)="viewOrEditEmployee(element)">View/Edit</button>
                                                <button mat-menu-item
                                                    (click)="inactivateEmployee(element, true)">Inactivate</button>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                [length]="allEmployeesData?.totalCompletedListCount" (page)="paginationEvent($event)"></mat-paginator>
                        </div>

                        <mat-divider *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0"></mat-divider>

                        <div class="text-center mt-2 p-2" *ngIf="dataSource && dataSource.data!=null  && dataSource.data.length <= 0">
                            No Records
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <div *ngIf="employeeViewBy != 'activeEmployees'">
                <div *ngIf="dataSource && dataSource.data !=null  && dataSource.data.length > 0">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                        <!-- Beneficiary Name Column -->
                        <ng-container matColumnDef="beneficiaryName">
                            <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.beneficiaryName}} </td>
                        </ng-container>

                        <!-- Email Column -->
                        <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef> Email </th>
                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                        </ng-container>

                        <!-- Date of Inactivation Column -->
                        <ng-container matColumnDef="lastDate">
                            <th mat-header-cell *matHeaderCellDef> Date of Inactivation </th>
                            <td mat-cell *matCellDef="let element"> {{element.lastDate}} </td>
                        </ng-container>

                        <!-- Company Column -->
                        <ng-container matColumnDef="company">
                            <th mat-header-cell *matHeaderCellDef> Company </th>
                            <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
                        </ng-container>

                        <!-- Source Column -->
                        <ng-container matColumnDef="source">
                            <th mat-header-cell *matHeaderCellDef> Source </th>
                            <td mat-cell *matCellDef="let element"> {{element.source}} </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="row">
                                    <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder"
                                        [matMenuTriggerFor]="menu">
                                        <mat-icon>settings</mat-icon>
                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                    </mat-icon>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item
                                            (click)="activateOrRehire(element, false)">Activate</button>
                                    </mat-menu>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Header and Row Declarations -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                        [length]="dataSource.data.length" (page)="paginationEvent($event)"></mat-paginator>
                </div>


                <mat-divider *ngIf="dataSource && dataSource.data !=null  && dataSource.data.length <= 0"></mat-divider>

                <div class="text-center mt-2 p-2" *ngIf="dataSource && dataSource.data !=null  && dataSource.data.length <= 0">
                    No Records
                </div>
            </div>
        </div>

        <div *ngIf="userType !== 'I9Admin'">
            <div class="mat-elevation-z8 mt-2" *ngIf="this.totalRecordCount > 0">
                <table class="im-card-no-border-table table im-card-table-noborder-spacing bene-list" mat-table [dataSource]="dataSource" matSort>
        
        
                <ng-container *ngIf="beneficiaryStatus === 'PETITION_APPROVED'" matColumnDef="select">
                    <th class="checkbox" mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle($event) : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [disabled]="!checkIfAllDisabled()"
                                    >
                    </mat-checkbox>
                    </th>
                    <td class="checkbox"  mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)"
                                    [disabled]="row.status !== 'ACTIVE'" >
                    </mat-checkbox>
                    </td>
                </ng-container>
        
        
                <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span *ngIf="column.header != 'Accepted On'">{{column.header}}</span>
                    <span *ngIf="column.header === 'Accepted On'">
                        {{beneficiaryStatus == 'ACTIVE' || 'PETITION_APPROVED' ? 'Accepted On' : (beneficiaryStatus == 'PEND' ? 'Invite Sent On' :
                        'Comments') }}</span>
                    </th>
        
                    <td mat-cell *matCellDef="let row"> <span
                        *ngIf="column.header != 'Accepted On' && column.columnDef != 'action' && column.columnDef != 'type' && column.columnDef != 'relative' && column.columnDef != 'status'">{{row[column.columnDef]}}</span>
                    <span *ngIf="column.columnDef === 'type'"> {{row.primaryContact && row.primaryContact==='sponsor'?'Sponsor':row.primaryContact &&
                        row.primaryContact==='applicant'?'Applicant':'Individual'}}</span>
        
                    <span *ngIf="column.columnDef === 'status'">
                        <span class="petition-approved-text" *ngIf="row.status === 'ACTIVE'">Petition Approved</span>
                        <span class="migrated-text" *ngIf="row.status !== 'ACTIVE'">Onboarded</span>
                    </span>
                    
        
                    <span *ngIf="column.columnDef === 'relative'"> {{ row.relative || 'NA' }}</span>
                    <div class="row" *ngIf="column.header === 'Accepted On'">
                        <span *ngIf="beneficiaryStatus == 'ACTIVE' || 'PETITION_APPROVED'">{{row?.approvedOn}}</span>
                        <span *ngIf="beneficiaryStatus == 'Current'">{{row?.modeOfCreationName}}</span>
                        <span *ngIf="beneficiaryStatus == 'PEND'">{{row?.inviteSentOn ? (row?.inviteSentOn | date:'dd-MMM-yyyy' )
                        : ''}}</span>
                        <span *ngIf="beneficiaryStatus == 'Past'">{{row?.comments}}</span>
                    </div>
                    <div class="row" *ngIf="column.columnDef == 'action'">
                        <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                        <mat-icon>settings</mat-icon>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                        </mat-icon>
                        <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="openBeneProfileDetails(row)" *ngIf="beneficiaryStatus == 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED'">View profile</button>
        
                        <button mat-menu-item (click)="openBeneProfileDetails(row, true)" *ngIf="beneficiaryStatus == 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED'">View Petitions</button>
        
                        <button mat-menu-item (click)="openBeneProfileDetails(row, false, true)" *ngIf="beneficiaryStatus == 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED'">View LCA</button>
        
                        <!-- Ticket IM-14077 -->
                        <button mat-menu-item *ngIf="row.modeOfCreationCode === 'CREATED' && (beneficiaryStatus === 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED')"
                        (click)="sendInviteBeneficiary(row)">Send Invite</button> 
                        
                        <button mat-menu-item (click)="deLinkBeneficiary(row)" *ngIf="row.modeOfCreationCode === 'CREATED' && (beneficiaryStatus === 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED')" >De-link</button> 
                        <!-- Ticket IM-14077 -->
        
        
                        <button mat-menu-item (click)="openUpdateEmployment(row, 'start')"
                            *ngIf="beneficiaryStatus === 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED'">
                            Update Employment</button>
                        <!-- <button mat-menu-item (click)="openFormModal('SEND INVITE',row)"
                            *ngIf="beneficiaryStatus == 'Past' || row?.modeOfCreationName === 'Created'">
                            Send Invite</button> -->
                        <button mat-menu-item (click)="resendBeneficiaryInvite(row)" *ngIf="beneficiaryStatus == 'PEND'">
                            Resend Invite</button>
                        <button mat-menu-item (click)="withDrawnBeneficiaryInvite(row)" *ngIf="beneficiaryStatus == 'PEND'">
                            Withdraw Invite</button>
                        <button mat-menu-item (click)="updateInfo(row,'email')" *ngIf="beneficiaryStatus == 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED'">
                            Update Communication Email ID</button>                  
                        <button mat-menu-item (click)="openUpdateEmployment(row, 'i9')" *ngIf="beneficiaryStatus === 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED'">
                            I-9</button>
        
        
                        <!-- <button mat-menu-item (click)="updateInfo(row,'userId')" *ngIf="row.externalBeneficiary">
                            Edit User ID</button> -->
                        <!--<button mat-menu-item (click)="updateInfo(row,'eer')" *ngIf="row.externalBeneficiary">
                            Edit Employer Employee Relationship</button>   -->
                        <!-- <button mat-menu-item  *ngIf="userType != 'Attorney' && beneficiaryStatus == 'Current'">Terminate</button> -->
                        <!-- IM-3352 (IM-3335) user story currently hiding -->
                        <button mat-menu-item (click)="requestDataDocuments(row)" *ngIf="beneficiaryStatus === 'ACTIVE' || beneficiaryStatus == 'PETITION_APPROVED'">Request Data & Documents</button>
                        <button mat-menu-item (click)="initiateCaseRequest(row)">Initiate Case Request</button>
                        </mat-menu>
                    </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
                </table>
                <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalRecordCount"
                (page)="paginationEvent($event)"></mat-paginator>
            </div>
            <mat-divider *ngIf="this.totalRecordCount <= 0"></mat-divider>
            <div class="text-center mt-2 p-2" *ngIf="this.totalRecordCount <= 0">
                No Records
            </div>
        </div>
    </div>
    <p-confirmDialog header="Delete" key="deletePastDoc"></p-confirmDialog>
</div>
<p-confirmDialog [style]="{width: '50vw'}" rejectButtonStyleClass="p-button-text"></p-confirmDialog>


<!-- I9 FORM DETAILS -->
<p-dialog header="Fill I-9 Profile" [(visible)]="I9Form" [modal]="true" [style]="{ width: '70vw' }" [draggable]="false"
    [resizable]="false">
    <form (ngSubmit)="i9FormSubmit(form)" #form="ngForm">
        <div class="row">
            <div class="col-md-4">
                <label class="label-cls required">First Name</label>
                <input type="text" placeholder="Enter First Name" [(ngModel)]="i9form.fname" name="fname"
                    #fname="ngModel" required />
                <div class="invalid-message" *ngIf="fname?.touched && fname?.errors?.required">Required field.</div>
            </div>
            <div class="col-md-4">
                <label class="label-cls">Middle Name</label>
                <input type="text" placeholder="Enter Middle Name" [(ngModel)]="i9form.mname" name="mname"
                    #mname="ngModel" />
            </div>
            <div class="col-md-4">
                <label class="label-cls required">Last Name</label>
                <input type="text" placeholder="Enter Last Name" name="lname" [(ngModel)]="i9form.lname"
                    #lname="ngModel" required />
                <div class="invalid-message" *ngIf="lname?.touched && lname?.errors?.required">Required field.</div>
            </div>

        </div>

        <div class="row mt-3">

            <div class="col-md-4">
                <label class="label-cls required">Date of Birth</label>
                <div classs="clearfix"></div>
                <p-calendar placeholder="mm/dd/yy" name="dob" #dob="ngModel" [(ngModel)]="i9form.dob" [showIcon]="true"
                    [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2100" appendTo="body"
                    [style]="{'width':'100%'}"></p-calendar>
                <div class="invalid-message" *ngIf="dob?.touched && dob?.errors?.required">Required field.</div>
            </div>

            <div class="col-md-4">
                <label class="label-cls required">Mobile Number</label>
                <input type="text" placeholder="Enter Mobile Number" name="mobile" #mobile="ngModel" required
                    [(ngModel)]="i9form.mobile" />
                <div class="invalid-message" *ngIf="mobile?.touched && mobile?.errors?.required">Required field.</div>
            </div>
            <div class="col-md-4">
                <label class="label-cls required">Email</label>
                <input type="text" placeholder="Enter Email" name="email" #email="ngModel" required
                    [(ngModel)]="i9form.email" />
                <div class="invalid-message" *ngIf="email?.touched && email?.errors?.required">Required field.</div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-4">
                <label class="label-cls required">Address (Street Name & Number)</label>
                <input type="text" placeholder="Enter Address" name="address" #address="ngModel" required
                    [(ngModel)]="i9form.address" />
                <div class="invalid-message" *ngIf="address?.touched && address?.errors?.required">Required field.</div>
            </div>

            <div class="col-md-4">
                <label class="label-cls">Apt Number</label>
                <input type="text" placeholder="Enter Apartment" name="apartment" #apartment="ngModel"
                    [(ngModel)]="i9form.apartment" />
            </div>

            <div class="col-md-4">
                <label class="label-cls required">City/Town</label>
                <input type="text" placeholder="Enter City" name="city" #city="ngModel" required
                    [(ngModel)]="i9form.city" />
                <div class="invalid-message" *ngIf="city?.touched && city?.errors?.required">Required field.</div>
            </div>
        </div>

        <div class="row mt-3">

            <div class="col-md-4">
                <label class="label-cls required">State</label>


                <p-dropdown #dd [options]="stateList" [(ngModel)]="i9form.stateProvinceCode" [style]="{'width':'100%'}"
                    scrollHeight="200px" optionLabel="stateProvinceName" optionValue="stateProvinceCode" filter="true"
                    filterBy="stateProvinceName,stateProvinceCode" resetFilterOnHide="true"
                    (onChange)="profileSateChange($event, state)" (keyup.enter)="profileSateChange($event, state)"
                    name="state" #state="ngModel">

                    <ng-template let-state pTemplate="item">
                        <div class="item-drop1">
                            <mat-list-item>
                                <span>{{state.stateProvinceName}}</span>
                            </mat-list-item>
                        </div>
                    </ng-template>
                </p-dropdown>


                <div class="invalid-message" *ngIf="state?.touched && state?.errors?.required">Required field.</div>
            </div>


            <div class="col-md-4">
                <label class="label-cls required">Zip Code</label>
                <input type="text" placeholder="Enter ZipCode" name="zipcode" #zipcode="ngModel" required
                    [(ngModel)]="i9form.zipcode" />
                <div class="invalid-message" *ngIf="zipcode?.touched && zipcode?.errors?.required">Required field.</div>
            </div>

            <div class="col-md-4">
                <label class="label-cls">U.S Social Security Number</label>
                <input type="text" placeholder="Enter SSN" class="form-control" name="ssn" [(ngModel)]="i9form.ssn"
                    #ssn="ngModel" />
            </div>

        </div>

        <div class="row mt-3 mb-3">
            <div class="col-md-12">
                <button class="btn btn-primary float-right" [disabled]="form.invalid">Submit</button>
            </div>
        </div>
    </form>

</p-dialog>

<p-dialog [draggable]="false" styleClass="bgColorChange" *ngIf="displayModal" [(visible)]="displayModal" [style]="{width: '50vw'}" [baseZIndex]="10000" appendTo="body">
    <hr>
  
    <ng-template pTemplate="header">
      <div class="eVerifyHeader">
        <h3>Ready to e-file </h3>
        <p>Follow the below steps to E-file</p>
      </div>
    </ng-template>
  
    <div class="eVerifyContent">
      <h3> E-Verify the I-9 Form</h3>
  
      <div>
        <div style="width: 48%; float: left;"> <p>You have not installed the Tracker E-Verify Utility yet. Download the installer now</p></div>
        <div class="row">
          <div class="col-12">
             <label>Please select installed OS in your machine</label>
          </div>
          <div class="col-12">
             <p-radioButton class="mr-2" name="os" label="Mac / Linux" value="unix" [(ngModel)]="selectedOS"></p-radioButton>
              <p-radioButton name="os" label="Windows" value="windows" [(ngModel)]="selectedOS"></p-radioButton>
              <div class="downloadBtn mt-1">
                <!-- <a href="https://pl.imagility.co/remote-i9/application/E-Verify/ImagilityEverify.zip" target="_blank">
                 <p-button label="Download" styleClass="p-button-sm p-button-secondary"></p-button>
                </a> -->
                <p-button label="Download" styleClass="p-button-sm p-button-secondary" (click)="downloadUrl()"></p-button>
              </div>
          </div>
         </div>
        
      </div>
  
      <div class="clearfix"></div>
  
      <h4> Use the following information to login to Tracker E-Utility</h4>
  
      <div class="clearfix"></div>
  
      <div> 
        <b>Enrollmeant:</b> Please enroll as employer on USCIS PORTAL. if you are not. <a href="https://www.e-verify.gov/about-e-verify/e-verify-data/how-to-find-participating-employers" target="_blank">CLICK HERE</a>
      </div>
  
      
      <div class="userCredential height200">
  
        <div class="form-group displayBlocks">
          <label for="email" class="required"><b>User Id</b> (USCIS System):</label>
          <input type="email" required class="form-control" #email [(ngModel)]="eVerifyUserName" placeHolder="User Id" name="email">
        </div>
        
        <div class="clearfix pb-2"></div>
  
        <div class="form-group displayBlocks">
          <label for="passowrd" class="required"><b>Password</b> (USCIS System):</label>
          <input type="passowrd" required class="form-control" #password  [(ngModel)]="eVerifyPassword" placeholder="******" name="password">
        </div>
  
        <div class="clearfix"></div>
      </div>
      
    
    </div>
  
    <div class="clearfix"></div>
  
      <hr>
    <ng-template pTemplate="footer">
        <p-button (click)="displayModalFunc()" label="Cancel" styleClass="p-button-text"></p-button>
        <button type="button" class="btn btn-primary" [disabled]="!eVerifyPassword || !eVerifyPassword" (click)="postEverifyLogin()">Save and Launch</button>
      </ng-template>
    
  </p-dialog>
  <p-dialog [draggable]="false" styleClass="bgColorChange" *ngIf="statusModal" [(visible)]="statusModal" [style]="{width: '50vw'}">
    <hr>
  
    <ng-template pTemplate="header">
      <div class="eVerifyHeader">
        <h3>Edit Status</h3>
        <p>You can add Case Number and Edit Status here</p>
      </div>
    </ng-template>
  
    <div class="eVerifyContent">
  
      <div class="clearfix"></div>    
      <div class="userCredential">
        <div class="col-md-6 float-left">
          <p-dropdown (onChange)="handleStatusChange($event)" [options]="listOfStatus"
          [(ngModel)]="selectedStatus" optionValue="name" placeholder="Select Status"
          optionLabel="name" [showClear]="false" appendTo="body"></p-dropdown>       
        </div>
  
        <div class="col-md-6  float-right">
          <input 
          type="text" 
          required 
          class="form-control"
          [(ngModel)]="caseNumberUpdate"
          placeholder="Case Number" 
         />
        </div>
      </div>   
    
    </div>
  
    <div class="clearfix"></div>
  
      <hr>
    <ng-template pTemplate="footer">
        <p-button (click)="statusModalFunc()" label="Cancel" styleClass="p-button-text"></p-button>
        <button type="button" class="btn btn-primary" (click)="saveVerificationStatus()">Save</button>
    </ng-template>
    
  </p-dialog>